<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div [ngClass]="(locoStatus?.isLocoSelected)? 'lsc-loco-icon selectedDraged' : 'lsc-loco-icon'" *ngIf="locoStatus?.isLocoStatusLoaded" (click)="setSelectLoco($event);" id="loco{{locoStatus?.locomotiveIdentifier}}{{index}}" (contextmenu)='$event.preventDefault(); showLocoContextMenu(locoStatus);'>
    <div class="loco-status-loco-icon">
        <lms-loco-svg [loco]='locoStatus' [svgWidthClass]="'loco-top-svg'"></lms-loco-svg>
    </div>
</div>
<div class="lsc-loco-icon" *ngIf="!locoStatus?.isLocoStatusLoaded">&nbsp;</div>

<div class="lsc-loco-id">
    <input class="{{locoStatus?.isLocoError ? 'p-inputfield train-placeholder p-inputfield-error' : 'p-inputfield train-placeholder'}}" spellcheck="false" type='text' id="locoStatusSearchTextBox{{index}}" [ngModel]="locoStatus && locoStatus.searcheLocomotiveIdentifier" (ngModelChange)="locoStatus && (locoStatus.searcheLocomotiveIdentifier = $event)"
        tabindex="{{tabIndex + (index + 1)}}" (focus)='setPageMode($event);' (blur)='resetPageMode($event);' (keyup)="updateSearchText($event)" maxlength="14">
    <i class="fa fa-times input-clear-icon" id="locoStatusClearIcon{{index}}" *ngIf="locoStatus?.searcheLocomotiveIdentifier" (click)='removeLocomotiveId()'></i>
    <i class="fa fa-search" *ngIf="!locoStatus?.searcheLocomotiveIdentifier" id="locoStatusSearchIcon{{index}}" (click)='searchLoco();'></i>
    <div class="error-text clearfix" *ngIf='locoStatus?.isLocoError'>{{locoStatus.locoErrorMessage ? locoStatus.locoErrorMessage : ''}}</div>
    <span id="locoStatusDoubleEnterId{{index}}" (click)="loadLocoSearchText()"></span>
</div>

<div class="lsc-current-assgnmt" *ngIf="locoStatus?.isLocoStatusLoaded">{{locoStatus.currentAssignment ? locoStatus.currentAssignment : '-'}}</div>

<div class="lsc-frr" *ngIf="locoStatus?.isLocoStatusLoaded">{{locoStatus.subYard ? locoStatus.subYard : '-'}}</div>

<div class="lsc-tag" *ngIf="locoStatus?.isLocoStatusLoaded">{{locoStatus.permanentTag ? locoStatus.permanentTag : '-'}}</div>

<div class="lsc-class" *ngIf="locoStatus?.isLocoStatusLoaded">{{locoStatus.clazz ? locoStatus.clazz : '-'}}</div>

<div class="lsc-last-rpt" *ngIf="locoStatus?.isLocoStatusLoaded">{{locoStatus.lastReporting ? locoStatus.lastReporting : '-'}}</div>

<div class="lsc-city-state" *ngIf="locoStatus?.isLocoStatusLoaded">{{locoStatus.lastReportingCityState ? locoStatus.lastReportingCityState : '-'}}</div>

<!-- Start error popup for cancel locomotive plan -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="terminal-ui-popups error-dialog" header="Cancel Locomotive Plan" [(visible)]="cancelPlanErrorPopup" modal="true" (onShow)='setPageModeDialog("yardAndLocalLocoData");' (onHide)='cancelPlanErrorOpr();'
    closeOnEscape="true">
    <div class="dialog-container">
        <span>{{configData && configData.messages.cancelLocomotiveInvalid}}</span>
    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
			<button type="button" tabindex="2310" id='yardAndLocalLocoData' (click)="cancelPlanErrorOpr()" class="p-button-primary">{{configData && configData.locoStatusLabel.ok}}</button>
		</span>
    </div>
</p-dialog>
<!-- End error popup for cancel locomotive plan -->